import { render, staticRenderFns } from "./ShipmentRatingResponse.vue?vue&type=template&id=4bb3a4ac&scoped=true&"
import script from "./ShipmentRatingResponse.vue?vue&type=script&lang=js&"
export * from "./ShipmentRatingResponse.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentRatingResponse.vue?vue&type=style&index=0&id=4bb3a4ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3a4ac",
  null
  
)

export default component.exports